<template>
  <header id="u-client-header" class="has-border-bottom">
    <ribbon class="is-stretched">
      <u-padding
        class="is-paddingless-y is-spaced-apart"
        :class="{ 'has-padding-x-100': !$store.getters['ui/isDesktopPlus'] }"
      >
        <brand-logo v-bind="brandLogoArgs" fallback="text" />
        <div class="u-client-header-controls has-col-gap-75">
          <slot />
        </div>
      </u-padding>
    </ribbon>
  </header>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapGetters } from "vuex";
import { BrandConfigKeys } from "@/data/constants";
import { ClientRoutes } from "@/data/enums/router";

export default defineComponent({
  name: "ClientHeader",
  components: {
    "brand-logo": () => import("@/components/app/global/brand/logo.vue")
  },
  data: () => ({
    clientDashboardRoute: { name: ClientRoutes.DASHBOARD }
  }),
  computed: {
    ...mapGetters({
      brandConfig: "brand/config"
    }),
    logoUrl() {
      return this.brandConfig[BrandConfigKeys.UI_LOGO_URL];
    },
    brandLogoArgs() {
      return this.logoUrl
        ? { tag: "a", href: this.logoUrl }
        : { to: this.clientDashboardRoute };
    }
  }
});
</script>

<style lang="scss" scoped>
header#u-client-header {
  position: sticky;
  top: 0;
  display: flex;
  align-items: center;
  height: 4.5rem;
  width: 100%;
  z-index: 10;
  background: $white;
  .u-client-header-controls {
    display: flex;
    align-items: center;
  }
}
</style>
